import { clearFavoritesCache } from "@/features/favorites/favoritesCache";
import { queryClient } from "@/lib/providers/queryClient";
import { useWorkspaceStore } from "@/state/workspace.store";

/**
 * Clear every client-cached workspace reference.
 * Used on logout, org change, and workspace/org mismatch 403s.
 * Idempotent — safe to call from multiple paths.
 *
 * Order matters: clear the in-memory store first (zustand persist may write),
 * then remove the storage key so a null persist does not leave a zombie entry.
 */
export function clearWorkspaceScopedClientState(): void {
  try {
    useWorkspaceStore.getState().clearActiveWorkspace();
  } catch {
    // Best effort only.
  }

  // Favorites are org-scoped; drop all cached lists so a prior org never flashes.
  try {
    clearFavoritesCache(queryClient);
  } catch {
    // Best effort only.
  }

  try {
    const persistApi = (
      useWorkspaceStore as typeof useWorkspaceStore & {
        persist?: { clearStorage?: () => void };
      }
    ).persist;
    persistApi?.clearStorage?.();
  } catch {
    // Best effort only.
  }

  try {
    localStorage.removeItem("workspace-storage");
  } catch {
    // Best effort only.
  }

  try {
    localStorage.removeItem("zephix.lastWorkspaceId");
    localStorage.removeItem("zephix_last_workspace_v1");
    localStorage.removeItem("zephix_recent_workspaces_v1");
  } catch {
    // Best effort only.
  }
}
